import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TabMap } from '../common/TabNavigation'

import BlockHeading from '@healthwise-ui/core/BlockHeading'
import SectionHeading from '../SectionHeading'
import SubSectionHeading from '../SubSectionHeading'

const headingTypes = {
  sectionHeading: 'SectionHeading',
  subSectionHeading: 'SubSectionHeading',
  blockHeading: 'BlockHeading'
}

const HeadingMap = {
  'home': [
    headingTypes.sectionHeading,
    headingTypes.blockHeading
  ],
  'facts': [
    headingTypes.sectionHeading,
    headingTypes.blockHeading
  ],
  'compare': [
    headingTypes.sectionHeading
  ],
  'learn': [
    headingTypes.sectionHeading
  ],
  'decide': [
    headingTypes.sectionHeading,
    headingTypes.blockHeading,
    headingTypes.blockHeading,
    headingTypes.blockHeading
  ],
  'summary': [
    headingTypes.sectionHeading,
    headingTypes.blockHeading,
    headingTypes.blockHeading
  ]
}

class HeadingFactory extends Component {
  render () {
    const {children, currentLocation, sectionIndex, image} = this.props
    const headingType = HeadingMap[currentLocation][sectionIndex]
    switch (headingType) {
      case headingTypes.sectionHeading:
        return (<SectionHeading image={image}>{children}</SectionHeading>)
      case headingTypes.subSectionHeading:
        return (<SubSectionHeading>{children}</SubSectionHeading>)
    }
    return (<BlockHeading>{children}</BlockHeading>)
  }
}

HeadingFactory.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.node,
  currentLocation: PropTypes.oneOf(TabMap).isRequired,
  sectionIndex: PropTypes.number.isRequired
}

export default HeadingFactory



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/HeadingFactory/index.js